import { Suspect, User } from "../types";

interface Props {
  suspects: Suspect[];
  selectedSuspect: string | null;
  user: User | null;
  onAccuse: () => void;
  onAuthRequired: () => void;
}

export default function AccuseSection({
  suspects,
  selectedSuspect,
  user,
  onAccuse,
  onAuthRequired,
}: Props) {
  const chosen = suspects.find((s) => s.id === selectedSuspect);

  const handleClick = () => {
    if (!selectedSuspect) return;
    if (!user) {
      onAuthRequired();
      return;
    }
    onAccuse();
  };

  return (
    <div className="accuse-section">
      <p className="accuse-prompt">Who killed Harlow?</p>
      <p className="accuse-sub">
        {user
          ? "Select a suspect above, then commit. You can't change your answer."
          : "Select a suspect and create a free account to lock in your accusation."}
      </p>
      <button
        className="accuse-btn"
        onClick={handleClick}
        disabled={!selectedSuspect}
      >
        {chosen
          ? user
            ? `Accuse ${chosen.name}`
            : `Accuse ${chosen.name} — sign up to confirm`
          : "Select a suspect to accuse"}
      </button>
    </div>
  );
}
